import CartView from './CartView';

export default CartView;
